/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_ChooseInputs */

const en_gc_editor_choose = /** @type {(inputs: Gc_Editor_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your starting point`)
};

const zh_gc_editor_choose = /** @type {(inputs: Gc_Editor_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择你的起步方式`)
};

/**
* | output |
* | --- |
* | "Choose your starting point" |
*
* @param {Gc_Editor_ChooseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_choose = /** @type {((inputs?: Gc_Editor_ChooseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_ChooseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_choose(inputs)
	return zh_gc_editor_choose(inputs)
});
export { gc_editor_choose as "gc.editor.choose" }